import { Link } from 'react-router-dom';
import { sileo } from 'sileo';
import { useFavorites } from '../hooks/useFavorites';
import './EventCard.css';

const calendarIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%236d28d9' stroke-width='2' stroke-linecap='round'%3E%3Crect x='3' y='4' width='18' height='18' rx='2'/%3E%3Cline x1='16' y1='2' x2='16' y2='6'/%3E%3Cline x1='8' y1='2' x2='8' y2='6'/%3E%3Cline x1='3' y1='10' x2='21' y2='10'/%3E%3C/svg%3E";
const clockIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%236d28d9' stroke-width='2' stroke-linecap='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpolyline points='12 6 12 12 16 14'/%3E%3C/svg%3E";
const locationIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%236d28d9' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z'/%3E%3Ccircle cx='12' cy='10' r='3'/%3E%3C/svg%3E";
const arrowIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round'%3E%3Cline x1='5' y1='12' x2='19' y2='12'/%3E%3Cpolyline points='12 5 19 12 12 19'/%3E%3C/svg%3E";

// Íconos de corazón: contorno (trazo blanco) y relleno (rojo)
const heartOutline = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E";
const heartFilled = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='%23ef4444' stroke='%23ef4444' stroke-width='2'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E";

export default function EventCard({ id, image, category, date, time, venue, city, title, price, slug }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const liked = id ? isFavorite(id) : false;

  const handleFav = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!id) return;
    const wasLiked = isFavorite(id);
    toggleFavorite(id);
    sileo.show({
      title: wasLiked ? 'Removido de favoritos' : 'Agregado a favoritos',
      description: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center', width: '100%', boxSizing: 'border-box' }}>
          {image && (
            <img src={image} alt="" style={{ width: 64, height: 64, borderRadius: '0 12px 0 12px', objectFit: 'cover' }} />
          )}
          <div style={{ fontSize: 13, fontWeight: 700, color: '#3e0f9e', lineHeight: 1.3, textAlign: 'center', padding: '0 10px' }}>
            {title || 'Evento'}
          </div>
        </div>
      ),
      fill: '#fbf5fd',
      duration: 3000,
    });
  };

  const card = (
    <article className="tarjeta-evento">
      <div className="tarjeta-evento__image-wrap">
        <img src={image} alt={title} width="400" height="210" loading="lazy" />
        <span className="tarjeta-evento__badge">{category}</span>
        <button className={`tarjeta-evento__fav ${liked ? 'tarjeta-evento__fav--liked' : ''}`} onClick={handleFav}>
          <img src={liked ? heartFilled : heartOutline} alt="Favorito" />
        </button>
      </div>
      <div className="tarjeta-evento__content">
        <div className="tarjeta-evento__meta">
          <div className="tarjeta-evento__meta-line">
            <img className="tarjeta-evento__meta-icon" src={calendarIcon} alt="" />
            <span className="tarjeta-evento__meta-text">{date}</span>
          </div>
          {time && (
            <div className="tarjeta-evento__meta-line">
              <img className="tarjeta-evento__meta-icon" src={clockIcon} alt="" />
              <span className="tarjeta-evento__meta-text">{time}</span>
            </div>
          )}
          {city && (
            <div className="tarjeta-evento__meta-line">
              <img className="tarjeta-evento__meta-icon tarjeta-evento__meta-icon--loc" src={locationIcon} alt="" />
              <span className="tarjeta-evento__meta-text">{city}</span>
            </div>
          )}
        </div>
        <h4 className="tarjeta-evento__title">{title}</h4>
        <div className="tarjeta-evento__footer">
          <div>
            <p className="tarjeta-evento__price-label">Precio desde</p>
            <p className="tarjeta-evento__price-value">{price}</p>
          </div>
          <button className="tarjeta-evento__action">
            <img src={arrowIcon} alt="Ver detalle" />
          </button>
        </div>
      </div>
    </article>
  );

  if (slug) {
    return <Link to={`/eventos/${slug}`} className="tarjeta-evento__link">{card}</Link>;
  }
  return card;
}
